<template>
  <div v-if="userHabilitation && (backendVersion || frontendCommit)" class="version-info">
    <span v-if="frontendCommit" class="version-item" title="Version Front-end">
      <v-icon small>mdi-desktop-classic</v-icon>
      <span>{{ frontendCommit }}</span>
    </span>

    <span v-if="backendVersion" class="version-item" title="Version Back-end">
      <v-icon small>mdi-server</v-icon>
      <span>{{ backendVersion.commit }}</span>
    </span>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'VersionInfo',
  data() {
    return {
      frontendCommit: process.env.VUE_APP_COMMIT_SHA,
    };
  },
  computed: {
    ...mapState('user', { userHabilitation: (state) => state.habilitation }),
    ...mapState('appInfo', ['backendVersion']),
  },
  methods: {
    ...mapActions('user', ['hasPermissionIn', 'signOut']),
  },
};
</script>

<style scoped>
.version-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  font-size: 0.8em;
  color: #888;
  text-align: right;
  padding: 0 16px 8px 16px;
  cursor: default;
}

.version-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>
